<div class="h-full">
  @if (cajaAbierta() === true) {
    <div class="grid grid-cols-1 lg:grid-cols-12 gap-3 sm:gap-4 h-full min-h-0">
      <div class="lg:col-span-7 flex flex-col h-full min-h-0">
        <div class="shrink-0 flex items-center gap-2 mb-3">
          <div class="flex-1">
            <app-input-buscador
              #inputBuscador
              [placeholder]="'Buscar producto por nombre o SKU...'"
              [(valor)]="terminoBusqueda"
              (presionaEnter)="onBuscarProducto()"
            />
          </div>
          @if (puedeEscanearConCamara) {
            <button
              type="button"
              (click)="abrirEscaner()"
              class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent-600 text-white shadow-sm transition-transform active:scale-95"
              aria-label="Escanear producto con la cámara"
            >
              <i class="bi bi-upc-scan text-xl"></i>
            </button>
          }
          <label class="flex items-center gap-2 cursor-pointer select-none">
            <span class="hidden text-xs text-slate-500 sm:inline sm:text-sm">Imágenes</span>

            <div class="relative">
              <input
                type="checkbox"
                class="sr-only peer"
                [checked]="verImagen()"
                (change)="toggleVerImagen($any($event.target).checked)"
              />

              <div
                class="w-10 h-5 bg-slate-300 rounded-full transition-colors duration-150 peer-checked:bg-accent-600"
              ></div>

              <div
                class="absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow-sm transition-all duration-150 peer-checked:translate-x-5"
              ></div>
            </div>
          </label>
        </div>

        <div class="lg:hidden shrink-0 mb-3 grid grid-cols-2 gap-2">
          <div class="col-span-2 bg-white border border-slate-200 px-3 py-3 rounded-xl shadow-sm">
            <div class="flex items-center justify-between gap-2">
              <div class="flex items-center gap-2">
                <span
                  class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-accent-50 text-accent-600 ring-1 ring-accent-100"
                >
                  <i class="bi bi-safe2 text-sm"></i>
                </span>
                <div>
                  <p class="text-slate-500 text-[11px] uppercase tracking-wide font-semibold">
                    Efectivo en Caja
                  </p>
                  <div class="flex items-center gap-2 mt-0.5">
                    @if (loaderMontoCaja() === true) {
                      <app-progress-spinner strokeWidth="8" size="16" />
                    } @else if (mostrarMontoCaja() && montoCaja() !== undefined) {
                      <p class="text-slate-900 text-base font-bold">
                        {{ montoCaja() | currency: 'PEN' : 'S/. ' }}
                      </p>
                    } @else if (mostrarMontoCaja()) {
                      <p class="text-slate-400 text-base font-medium">***.**</p>
                    } @else {
                      <p class="text-slate-400 text-base font-medium">••••••</p>
                    }
                  </div>
                </div>
              </div>
              <button
                type="button"
                class="shrink-0 rounded-lg p-2 text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors"
                (click)="toggleMostrarMontoCaja()"
                [attr.aria-label]="mostrarMontoCaja() ? 'Ocultar monto' : 'Mostrar monto'"
              >
                <i
                  class="bi text-sm"
                  [class.bi-eye]="!mostrarMontoCaja()"
                  [class.bi-eye-slash]="mostrarMontoCaja()"
                ></i>
              </button>
            </div>
          </div>

          <button
            type="button"
            class="flex items-center justify-center gap-1.5 px-3 py-3 bg-emerald-50 text-emerald-700 border border-emerald-100 rounded-xl hover:bg-emerald-100 transition-colors text-sm font-semibold"
            (click)="modal_agregar_ingreso.set(true)"
          >
            <i class="bi bi-plus-circle text-base"></i>
            <span>Ingreso</span>
          </button>
          <button
            type="button"
            class="flex items-center justify-center gap-1.5 px-3 py-3 bg-red-50 text-red-700 border border-red-100 rounded-xl hover:bg-red-100 transition-colors text-sm font-semibold"
            (click)="modal_agregar_egreso.set(true)"
          >
            <i class="bi bi-dash-circle text-base"></i>
            <span>Egreso</span>
          </button>
          <button
            type="button"
            class="col-span-2 flex items-center justify-center gap-1.5 px-3 py-3 bg-accent-50 text-accent-700 border border-accent-100 rounded-xl hover:bg-accent-100 transition-colors text-sm font-semibold"
            (click)="modal_cuadre_cierre.set(true)"
          >
            <i class="bi bi-wallet text-base"></i>
            <span>Cuadrar caja</span>
          </button>
        </div>

        @if (productoPaginar() != null) {
          <div class="flex-1 flex flex-col min-h-0">
            <div class="flex-1 overflow-y-auto pr-1 mb-3">
              <div
                class="grid grid-cols-[repeat(auto-fit,minmax(140px,1fr))] gap-3 sm:gap-4"
                [class.gap-4]="verImagen() === true"
              >
                @for (producto of productoPaginar()!.data; track $index) {
                  <app-card-producto
                    [producto]="producto"
                    (onSelectProducto)="agregarProductoCarrito($event)"
                    [verImagen]="verImagen()"
                  />
                }
              </div>
            </div>
            <div class="shrink-0 py-2 border-t border-slate-100">
              <app-paginacion
                [items]="productoPaginar()!.data"
                [itemsPorPagina]="itemsPorPagina"
                [totalItems]="productoPaginar()!.total"
                (paginaCambiada)="cambiarPagina($event)"
              />
            </div>
          </div>
        }
      </div>

      <div class="hidden lg:flex lg:col-span-5 lg:flex-col lg:min-h-0 gap-4">
        <div class="shrink-0 bg-white rounded-2xl border border-slate-200 p-4 shadow-sm">
          <div class="flex items-center justify-between mb-4">
            <div class="flex items-center gap-3">
              <span
                class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent-50 text-accent-600 ring-1 ring-accent-100"
              >
                <i class="bi bi-safe2 text-xl"></i>
              </span>
              <div>
                <p class="text-[10px] font-black uppercase tracking-widest text-slate-400">
                  Efectivo en Caja
                </p>
                <div class="flex items-center gap-2 mt-1">
                  @if (loaderMontoCaja() === true) {
                    <app-progress-spinner strokeWidth="8" size="20" />
                  } @else if (mostrarMontoCaja() && montoCaja() !== undefined) {
                    <span class="text-2xl font-extrabold text-slate-900 tracking-tight">
                      {{ montoCaja() | currency: 'PEN' : 'S/. ' }}
                    </span>
                  } @else if (mostrarMontoCaja()) {
                    <span class="text-2xl font-extrabold text-slate-400 tracking-tight"
                      >***.**</span
                    >
                  } @else {
                    <span class="text-2xl font-extrabold text-slate-300 tracking-tight"
                      >••••••</span
                    >
                  }
                </div>
              </div>
            </div>
            <button
              type="button"
              class="shrink-0 rounded-lg p-2 text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors"
              (click)="toggleMostrarMontoCaja()"
              [attr.aria-label]="mostrarMontoCaja() ? 'Ocultar monto' : 'Mostrar monto'"
            >
              <i
                class="bi text-lg"
                [class.bi-eye]="!mostrarMontoCaja()"
                [class.bi-eye-slash]="mostrarMontoCaja()"
              ></i>
            </button>
          </div>

          <div class="grid grid-cols-3 gap-2">
            <button
              (click)="modal_agregar_ingreso.set(true)"
              class="flex flex-col items-center gap-1 p-2 rounded-xl bg-emerald-50 text-emerald-700 border border-emerald-100 hover:bg-emerald-100 transition-all"
            >
              <i class="bi bi-plus-circle-fill text-lg"></i>
              <span class="text-[10px] font-bold uppercase">Ingreso</span>
            </button>
            <button
              (click)="modal_agregar_egreso.set(true)"
              class="flex flex-col items-center gap-1 p-2 rounded-xl bg-rose-50 text-rose-700 border border-rose-100 hover:bg-rose-100 transition-all"
            >
              <i class="bi bi-dash-circle-fill text-lg"></i>
              <span class="text-[10px] font-bold uppercase">Egreso</span>
            </button>
            <button
              (click)="modal_cuadre_cierre.set(true)"
              class="flex flex-col items-center gap-1 p-2 rounded-xl bg-accent-50 text-accent-700 border border-accent-100 hover:bg-accent-100 transition-all"
            >
              <i class="bi bi-calculator-fill text-lg"></i>
              <span class="text-[10px] font-bold uppercase">Cuadrar</span>
            </button>
          </div>
        </div>

        <div
          class="flex-1 min-h-0 bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm"
        >
          <app-carrito-compra (emitirVenta)="onVentaEmitida()" />
        </div>
      </div>
    </div>

    @if (isMobile()) {
      <button
        (click)="toggleCarritoMovil()"
        class="fixed bottom-6 right-6 bg-accent-600 text-white rounded-full w-16 h-16 flex items-center justify-center shadow-lg hover:bg-accent-500 active:scale-95 transition-all z-40"
      >
        <i class="bi bi-cart4 text-2xl"></i>
        @if (cantidadProductosCarrito > 0) {
          <span
            class="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center shadow-md"
          >
            {{ cantidadProductosCarrito }}
          </span>
        }
      </button>
    }

    @if (isMobile() && mostrarCarritoMovil()) {
      <div class="fixed inset-0 bg-black bg-opacity-50 z-50" (click)="toggleCarritoMovil()"></div>
      <div
        class="fixed inset-x-0 bottom-0 z-50 flex h-[90dvh] max-h-[90dvh] flex-col overflow-hidden rounded-t-3xl bg-white shadow-2xl"
      >
        <div class="flex shrink-0 items-center justify-between border-b border-slate-200 px-4 py-3">
          <div>
            <h3 class="text-base font-extrabold text-slate-900">Carrito de compra</h3>
            <p class="text-xs text-slate-500">
              Desliza para revisar los productos y cobra al final
            </p>
          </div>
          <button
            type="button"
            (click)="toggleCarritoMovil()"
            class="rounded-full p-2 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-700"
          >
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div class="flex-1 min-h-0 overflow-hidden">
          <app-carrito-compra (emitirVenta)="onVentaEmitida()" />
        </div>
      </div>
    }

    @if (scannerAbierto()) {
      <app-escaner-codigo
        [aviso]="avisoEscaner()"
        [pausado]="productoDuplicado() !== null"
        (codigoDetectado)="onCodigoEscaneado($event)"
        (cerrar)="cerrarEscaner()"
      />
    }

    @if (productoDuplicado(); as producto) {
      <div
        class="fixed inset-0 z-[80] flex items-end justify-center bg-black/60 p-4 sm:items-center"
        role="dialog"
        aria-modal="true"
        aria-labelledby="titulo-producto-duplicado"
      >
        <div class="w-full max-w-sm rounded-2xl bg-white p-5 shadow-2xl">
          <div class="flex items-start gap-3">
            <span
              class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-amber-50 text-amber-600 ring-1 ring-amber-100"
            >
              <i class="bi bi-bag-check text-xl"></i>
            </span>
            <div class="min-w-0">
              <h3 id="titulo-producto-duplicado" class="text-base font-extrabold text-slate-900">
                Ya está en el carrito
              </h3>
              <p class="mt-1 text-sm text-slate-600">
                <span class="font-semibold text-slate-800">{{ producto.nombre }}</span> ya tiene
                {{ cantidadEnCarrito(producto.id) }}
                {{ cantidadEnCarrito(producto.id) === 1 ? 'unidad' : 'unidades' }} en el carrito.
              </p>
              <p class="mt-1 text-xs text-slate-500">¿Deseas agregar otra unidad?</p>
            </div>
          </div>

          <div class="mt-4 grid grid-cols-2 gap-2">
            <button
              type="button"
              (click)="cancelarAgregarDuplicado()"
              class="rounded-xl border border-slate-200 px-3 py-2.5 text-sm font-semibold text-slate-600 transition-colors hover:bg-slate-50"
            >
              No, continuar
            </button>
            <button
              type="button"
              (click)="confirmarAgregarDuplicado()"
              class="rounded-xl bg-accent-600 px-3 py-2.5 text-sm font-bold text-white transition-transform active:scale-95"
            >
              Sí, agregar
            </button>
          </div>
        </div>
      </div>
    }

    @if (modal_agregar_ingreso() === true) {
      <app-dialog
        header="Agregar Ingreso"
        [modal]="true"
        [(visible)]="modal_agregar_ingreso"
        (onHide)="modal_agregar_ingreso.set(false)"
        size="sm"
      >
        <app-form-monto-descripcion
          form_titulo="Agregar Ingreso"
          form_monto_texto="Monto Inicial *"
          form_descripcion_texto="Descripción"
          [form_descripcion_opcional]="false"
          [form_descripcion_maximo_caracteres]="125"
          form_boton_confirmar_texto="Confirmar Ingreso"
          form_boton_cancelar_texto="Cancelar"
          form_anuncio="El ingreso es el dinero adicional que se agrega a la caja durante el turno."
          confirmar_titulo="Confirmar Agregar Ingreso"
          confirmar_texto="¿Estás seguro de que deseas agregar este ingreso?"
          confirmar_boton_confirmar_texto="Sí, confirmar"
          confirmar_boton_cancelar_texto="Cancelar"
          (cerrar)="onAgregarIngreso($event)"
          [tiene_tipo_pago]="true"
        />
      </app-dialog>
    }
    @if (modal_agregar_egreso() === true) {
      <app-dialog
        header="Agregar Egreso"
        [modal]="true"
        [(visible)]="modal_agregar_egreso"
        (onHide)="modal_agregar_egreso.set(false)"
        size="sm"
      >
        <app-form-monto-descripcion
          form_titulo="Agregar Egreso"
          form_monto_texto="Monto Inicial *"
          form_descripcion_texto="Descripción (opcional)"
          [form_descripcion_opcional]="false"
          [form_descripcion_maximo_caracteres]="125"
          form_boton_confirmar_texto="Confirmar Egreso"
          form_boton_cancelar_texto="Cancelar"
          form_anuncio="El egreso es el dinero que se retira de la caja durante el turno."
          confirmar_titulo="Confirmar Agregar Egreso"
          confirmar_texto="¿Estás seguro de que deseas Agregar este egreso?"
          confirmar_boton_confirmar_texto="Sí, confirmar"
          confirmar_boton_cancelar_texto="Cancelar"
          (cerrar)="onAgregarEgreso($event)"
          [tiene_tipo_pago]="true"
        />
      </app-dialog>
    }
    @if (modal_cuadre_cierre() === true) {
      <app-dialog
        header="Cuadre y Cierre de Caja"
        [modal]="true"
        [(visible)]="modal_cuadre_cierre"
        (onHide)="modal_cuadre_cierre.set(false)"
        size="6xl"
      >
        <app-cuadre-cierre (cerrar)="onCerrarCuadreCaja($event)" />
      </app-dialog>
    }
  } @else {
    <app-solicitud-desbloqueo
      titulo="Caja Cerrada"
      mensaje="Necesitas abrir la caja para acceder al punto de venta"
      botonTexto="Abrir Caja"
      (desbloquear)="modal_abrir_caja.set(true)"
    />
    <app-dialog
      header="Apertura de Caja"
      [modal]="true"
      [(visible)]="modal_abrir_caja"
      (onHide)="modal_abrir_caja.set(false)"
      size="sm"
    >
      <app-form-monto-descripcion
        form_titulo="Apertura de Caja"
        form_monto_texto="Monto Inicial *"
        form_descripcion_texto="Descripción (opcional)"
        [form_descripcion_opcional]="true"
        [form_descripcion_maximo_caracteres]="125"
        form_boton_confirmar_texto="Confirmar Apertura"
        form_boton_cancelar_texto="Cancelar"
        form_anuncio="El monto inicial es el dinero en efectivo con el que comenzará el turno de caja."
        confirmar_titulo="Confirmar Apertura de Caja"
        confirmar_texto="¿Estás seguro de que deseas abrir la caja con este monto inicial?"
        confirmar_boton_confirmar_texto="Sí, confirmar"
        confirmar_boton_cancelar_texto="Cancelar"
        (cerrar)="onApertura($event)"
        [tiene_tipo_pago]="false"
      />
    </app-dialog>
  }
</div>
